module.exports=require("./strokecount");